module.exports = __webpack_public_path__ + "static/media/expand.28fa704e.gif";